import { code128Widths } from "@/lib/code128";

/** A Code 128 barcode as SVG, with its text underneath */
export function Barcode({ value, height = 44, module = 1.6, showText = true }: { value: string; height?: number; module?: number; showText?: boolean }) {
  const widths = code128Widths(value);
  if (!widths) return <span className="text-xs text-muted-foreground">{value}</span>;
  const quiet = 10;
  let x = quiet;
  const bars: Array<{ x: number; w: number }> = [];
  widths.forEach((w, i) => {
    if (i % 2 === 0) bars.push({ x, w: w * module });
    x += w * module;
  });
  const total = x + quiet;
  return (
    <svg viewBox={`0 0 ${total} ${height + (showText ? 14 : 0)}`} width="100%" preserveAspectRatio="xMidYMid meet" role="img" aria-label={`Barcode ${value}`}>
      <rect width={total} height={height + (showText ? 14 : 0)} fill="#fff" />
      {bars.map((b, i) => (
        <rect key={i} x={b.x} y={0} width={b.w} height={height} fill="#000" />
      ))}
      {showText && (
        <text x={total / 2} y={height + 11} textAnchor="middle" fontSize="10" fontFamily="monospace" fill="#000">
          {value}
        </text>
      )}
    </svg>
  );
}
